<template>
  <div>
    <h2 class="kojin-title pc_only"><slot>タイトル</slot></h2>
  </div>
    <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #4169e1;" v-on:click="return_page()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control form-select" v-if="GlobalData.user_name && family_flg" v-bind:value="GlobalData.user_name" v-on:click.stop="multipleusers_change(0)" readonly="readonly">
        <input type="text" class="form-control" v-else-if="GlobalData.user_name && family_flg==false" v-bind:value="GlobalData.user_name" v-on:click.stop="multipleusers_change(1)" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-2 " style="margin-top:0;background-color:white">
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>{{ev}}
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    <div id="manual_area" >

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />お知らせのマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>

    </div>
      
    <br clear="all">
    
    <span class="sp_only" style="color:red;padding-top:10px">タップするとメールの内容を確認できます。</span>
    <b style="display: flex;
                  justify-content: space-evenly;
                  flex-direction: column;
                  align-items: flex-end;
                  font-size: 18px;
                  width:98%;
                  padding:10px 0;">{{ kensu }} 件</b>
        <!-- PC表示 -->
         <span class="pc_only">
        <div class="vy-search-result-row-head" style="width:98%;margin:auto">
          <!--
          <div class="vy-search-result-column-kojin-head-ins" style="width:25%">
            種類
          </div>-->
          
          <div class="vy-search-result-column-kojin-head-exp" style="width:55%">
            件名
          </div>
          <div class="vy-search-result-column-kojin-head-exp" style="width:10%">
            重要度
          </div>
          <div class="vy-search-result-column-kojin-head-exp" style="width:10%">
            状態
          </div>
          
          <div class="vy-search-result-column-kojin-head-ins" style="width:25%">
            日時
          </div>
        </div>
        <div class="vy-search-result" style="width:98%;margin:auto auto 10px auto;">
          <div v-for="(result,i) in results" v-bind:key="i" class="vy-search-result-row">
            
            <div class="vy-search-result-row-a"  v-on:click="Change_detail(result.mail_rireki_id,result.title,result.naiyou,result.critical,Timestamp(result.send_timestamp),result.kidoku,i)">
              <div  class="vy-search-result-column-kojin-exp" style="width:55%">
                {{result.title}}
            
              </div>
              <div  class="vy-search-result-column-kojin-exp" style="width:10%;">
                <span v-if="result.critical == true" style="color:red">重要</span>
              </div>
              <div  class="vy-search-result-column-kojin-exp" style="width:10%;">
                <span v-if="result.kidoku == 0" style="color:red">未読</span>
                <span v-else style="color:blue">既読</span>
                
            
              </div>
              
              <div class="vy-search-result-column-kojin-ins" style="width:25%">
                  {{Timestamp(result.send_timestamp)}}
                
              </div>
            </div>
          </div>
        </div>
      </span>
      
      <span class="sp_only" v-for="(result,i) in results" v-bind:key="i">
        

        <table style="width:98%;margin-bottom:10px" v-on:click="Change_detail(result.mail_rireki_id,result.title,result.naiyou,result.critical,Timestamp(result.send_timestamp),result.kidoku,i)">
         
           <tr style="background-color:red;color:white;"  v-if="result.critical == true" >
            <td colspan="2">重要</td>
          </tr>
          
          <tr style="color:white;">
            <td v-if="result.kidoku == 0" style="background-color:red">
              未読
            </td>
            <td v-else style="background-color:blue">
              既読
            </td>
            <td style="background-color: rgb(65, 105, 225);width:80%">
              {{result.title}}
            </td>
          </tr>
          <tr>
            <td >日時</td>
            <td>
              {{Timestamp(result.send_timestamp)}}
            </td>
          </tr>
        </table>

      </span>
  </div>
     
      <!-- メール送信履歴詳細・モーダルウィンドウ -->

      <div id="overlay" v-if="detail_area" >
          
          <div id="main" style="height: 90%;
                width: 95%;
                max-width: 1300px;
                min-height: 550px;
                max-height: 600px;
                background-color: white;
                padding: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;">
            <div style="text-align:left;padding:10px 0;margin-top: 10px;
              height:10%;
              width:100%;
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              justify-content: flex-end;">
              <div style="color: red;width: 100%;text-align: center;padding: 10px;"  v-if="disp_critical == true" ><b>【重要】</b></div>
              <div><b>送信日時</b>：{{ disp_nichiji }}</div>
              <div><b>件名</b>：{{ disp_title }}</div>
              
            </div>
            <textarea id="naiyou" v-model="disp_naiyou" style="width:100%;height:70%" readonly></textarea>
            <div style="height:10%">
              <button class="btn btn-primary" style="width:200px;height:40px;padding-top: 5px;margin-top: 10px;" v-on:click="Close_window">閉じる</button>
            </div>
          </div>
      </div>

            
</template>

<script setup>
/* eslint-disable */
import { ref,watchEffect } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { useStore } from 'vuex'
import axios from 'axios'
import { GlobalData  } from '../js/userdata.js';

const url = GlobalData.$API_URL
const router = useRouter();
const route = useRoute();
const store = useStore()

const emit = defineEmits(['call'])

  // URLから閲覧している社協の英名を取得
  let cityname = route.params.shakyo

// モーダルウィンドウの表示・非表示
let detail_area = ref(false)

// 親コンポーネント（ShakyoUser.vue）から送られてきた値
// param = {'results':results.value,"page":page,"page_read_count":page_read_count}
const props = defineProps(['param']);
  
let results = props.param.results //情報が全件入った配列
let kensu = ref(0)
if(results[0]){
  kensu.value = results[0].all_count
}

    emit('call',{ cmd:'loading_end_noreload' }) 

// メール詳細に表示する内容
let disp_nichiji = ref("")
let disp_title = ref("")
let disp_naiyou = ref("")
let disp_critical = ref(false)

/* 親コンポーネントに関わる関数 */

let family_flg = ref(false)  // 家族フラグ(家族の登録が出来る)が設定されている時は、右メニューのボタンが表示される

let family_flg_get_error = 0
const family_flg_get = () => {
    let res = null
    axios.post(GlobalData.$API_URL+"TaikenAccountUser_read", {taikenuser_id:GlobalData.user_id})
    .then(response => {
        
        if(response.data.accountuser){
            res = response.data.accountuser
            family_flg.value = res['family']

        } else {
            family_flg.value = false
        }
    })
    .catch(error => {
        if(family_flg_get_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get()},"1000")
        }
        
    })
}

family_flg_get()


/* コンポーネントの表示に関わる処理 */

// メール送信履歴詳細ウィンドウを開く
let Change_detail = function(rireki_id,title,naiyou,critical,send_date,kidoku,num){

  if(kidoku == 0){
    kidoku_set(rireki_id,num)
  }
  disp_title.value = title
  disp_naiyou.value = naiyou.replace(/<br>/g, '\n')
  disp_nichiji.value = send_date
  disp_critical.value = critical
  detail_area.value = true
}

// 既読フラグを立てる
let kidoku_error = 0
let kidoku_set = function(rireki_id,num){
  let update_array = {mail_rireki_id:rireki_id, update_user:GlobalData.$User_email,kidoku:1}
   
    axios.post(url+"Mail_rireki_update", update_array, GlobalData.$ID_Token)
    .then(response => {

      if(response.data.status == 0){
        results[num].kidoku = 1
      //  emit('call',{ cmd:'notification' }) 
      }
    })
    .catch(error => {
      if(kidoku_error == 6){
          message.value = error + GlobalData.$axios_error;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "movie_error";
          contentMessage.value = MessageModal
      }else{
          kidoku_error++
          setTimeout(function(){
            kidoku_set(rireki_id,num)
          },"1000")
      }
  })
}

// メール送信履歴詳細ウィンドウを閉じる
let Close_window = function(){
  detail_area.value = false
    emit('call',{ cmd:'loading_start' }) 
    emit('call',{ cmd:'notification' }) 
}

// HOMEへ戻る
const home = () =>{
  router.push("/"+cityname+"/Taiken")
}

// 前のページに戻る
let return_page = function(){
  
  let cmd = localStorage.getItem('return_cmd')
  let id =localStorage.getItem('return_id') 


  let return_url = location.protocol+'//'+location.host+"/"+cityname+"/Taiken"
  if(cmd != "undefined"){
    return_url += "/"+cmd
  }
  if(id != "undefined"){
    return_url += "/"+id
  }
  localStorage.removeItem('return_cmd')
  localStorage.removeItem('return_id')

  //alert(return_url)
  location.href = return_url
//  router.back()
}

/* その他関数の記述 */
 
let youbi_list = [ "日", "月", "火", "水", "木", "金", "土" ]
//タイムスタンプから日時を取り出す
let Timestamp = function(timestamp){  
    if(timestamp != "None"){
      let set_date = new Date(timestamp);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);

      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
    }
}
// ユーザー切替え画面の表示
const multipleusers_change = (parm) =>{
    if(parm == 1) return
    emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
}        

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/168c0be34f8f80769058f0d2fa14cece"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}     


/* 初期処理 */

</script>

<style scoped>
  #overlay{
    /* 要素を重ねた時の順番 */
    z-index:1;

    /* 画面全体を覆う設定 */
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color:rgba(0,0,0,0.5);

    /* 画面の中央に要素を表示させる設定 */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #content_modal{
    /* 要素を重ねた時の順番 */
    z-index:2;
    height:auto;
    text-align: center;
    padding: 1em;
    background:#fff;
    white-space: pre-line;
  }
  #content_modal button{
      width:120px;
      height: 30px;
      padding: 0;
  }

.vy-search-result-row-head,.vy-search-result{
 text-align: left; 
}

.vy-search-result-row-a{
  cursor: pointer;
}
@media screen and (min-width: 961px) {

/* PC版 */

  .sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .sp_button_area{
      display: flex
  }
}
</style>
